import React from 'react';
import ReactDOM from 'react-dom';
import registry from 'unilib-registry/instance';

require('./bootstrap');

const Root: React.FC = registry.get('Root');

ReactDOM.render(<Root />, document.getElementById('root'));
